module.exports = __webpack_public_path__ + "static/media/menuRegistro.0246891c.png";